// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, ButtonCell, Cell, Chip, Input, IconButton, List, Multiselectable, Select, Section } from '@telegram-apps/telegram-ui';

// AntD Mobile
import { Picker } from 'antd-mobile'

// Icons
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as ForceIcon } from "../assets/force.svg";
import { ReactComponent as MediaIcon } from "../assets/media.svg";
import { ReactComponent as OriginalIcon } from "../assets/original.svg";
import { ReactComponent as SourceIcon } from "../assets/source.svg";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";

const tg = window.Telegram.WebApp;

const FilterPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [timers, setTimers] = useState(stream.timer);
    const [keywords, setKeywords] = useState(stream.keywords)
    const [negative, setNegative] = useState(stream.negative)
    const [timezoneTimers, setTimeZoneTimers] = useState([]);
    const [days, setDays] = useState(stream.days);
    const [timezone, setTimezone] = useState(stream.shift ?? 0);
    const [timeVisible, setTimeVisible] = useState(false);
    const [keywordRef, setKeywordRef] = useState(null);
    const [negativeRef, setNegativeRef] = useState(null);

    const timeZones = [
        { gmt: "GMT-12 (Бейкер)", shift: -15 },
        { gmt: "GMT-11 (Паго-Паго)", shift: -14 },
        { gmt: "GMT-10 (Гонолулу)", shift: -13 },
        { gmt: "GMT-9 (Анкоридж)", shift: -12 },
        { gmt: "GMT-8 (Лос-Анджелес)", shift: -11 },
        { gmt: "GMT-7 (Денвер)", shift: -10 },
        { gmt: "GMT-6 (Чикаго, Мехико)", shift: -9 },
        { gmt: "GMT-5 (Нью-Йорк, Богота)", shift: -8 },
        { gmt: "GMT-4 (Сантьяго, Каракас)", shift: -7 },
        { gmt: "GMT-3 (Буэнос-Айрес, Бразилиа)", shift: -6 },
        { gmt: "GMT-2 (Среднеатлантическое время)", shift: -5 },
        { gmt: "GMT-1 (Азорские острова)", shift: -4 },
        { gmt: "GMT±0 (Лондон, Дакар)", shift: -3 },
        { gmt: "GMT+1 (Париж, Берлин, Лагос)", shift: -2 },
        { gmt: "GMT+2 (Калининград, Афины, Каир)", shift: -1 },
        { gmt: "GMT+3 (Москва, Санкт-Петербург, Казань)", shift: 0 },
        { gmt: "GMT+4 (Самара, Волгоград, Дубай, Баку)", shift: 1 },
        { gmt: "GMT+5 (Екатеринбург, Уфа, Ташкент)", shift: 2 },
        { gmt: "GMT+6 (Омск, Челябинск, Алматы)", shift: 3 },
        { gmt: "GMT+7 (Новосибирск, Красноярск, Бангкок)", shift: 4 },
        { gmt: "GMT+8 (Иркутск, Улан-Удэ, Пекин)", shift: 5 },
        { gmt: "GMT+9 (Якутск, Чита, Токио, Сеул)", shift: 6 },
        { gmt: "GMT+10 (Владивосток, Хабаровск, Сидней)", shift: 7 },
        { gmt: "GMT+11 (Магадан, Сахалин)", shift: 8 },
        { gmt: "GMT+12 (Камчатка, Анадырь, Окленд)", shift: 9 },
        { gmt: "GMT+13 (Тонга, Апиа)", shift: 10 },
        { gmt: "GMT+14 (Лайн-Айлендс)", shift: 11 }
    ];

    const generateTimeOptions = (start, end, suffix = '') => {
        const options = [];
        for (let i = start; i <= end; i++) {
            const label = i.toString().padStart(2, '0');
            options.push({ label, value: label + suffix });
        }
        return options;
    };

    const basicColumns = [
        generateTimeOptions(0, 23),
        [':'],
        generateTimeOptions(0, 59),
    ];

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'filter') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        const hrElement = document.querySelector('.sectionChannelTimersList hr');
        if (hrElement) {
            if (timers && timers.length > 0) {
                hrElement.style.display = 'block';
            } else {
                hrElement.style.display = 'none';
            }
        }
    }, [timers]);

    const handleAddKeyword = async () => {
        const url = 'https://api.gmpapp.ru/save_keywords';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, keyword: keywordRef }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                if (keywordRef && !keywords.includes(keywordRef)) {
                    const newKeywords = [...keywords, keywordRef];
                    setKeywords(newKeywords);
                    stream.keywords = newKeywords;
                }
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
        finally {
            setKeywordRef('');
        }
    };

    const handleDeleteKeyword = async (keywordToRemove) => {
        const url = 'https://api.gmpapp.ru/delete_keywords';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, keyword: keywordToRemove }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                const newKeywords = keywords.filter((keyword) => keyword !== keywordToRemove);
                setKeywords(newKeywords);
                stream.keywords = newKeywords;
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
    };

    const handleKeywordsPress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            handleAddKeyword(); // Вызов функции handleAddKeyword
        }
    };

    const handleAddNegative = async () => {
        const url = 'https://api.gmpapp.ru/save_negative';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, negative: negativeRef }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                if (negativeRef && !negative.includes(negativeRef)) {
                    const newNegative = [...negative, negativeRef];
                    setNegative(newNegative);
                    stream.negative = newNegative;
                }
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
        finally {
            setNegativeRef('');
        }
    };

    const handleDeleteNegative = async (negativeToRemove) => {
        const url = 'https://api.gmpapp.ru/delete_negative';

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, negative: negativeToRemove }),
            });

            if (!response.ok) {
                // Здесь можно обрабатывать неуспешные коды ответов
                console.error('Error:', response.status, response.statusText);
            } else {
                // Если ответ успешен, можно сделать что-то с данными
                const data = await response.json();
                console.log('Success:', data);
                const newNegative = negative.filter((item) => item !== negativeToRemove);
                setNegative(newNegative);
                stream.negative = newNegative;
            }
        } catch (error) {
            console.error('Error streams sending', error);
        }
    };

    const handleNegativePress = (e) => {
        // Если нажата клавиша Enter или введен знак запятой
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault(); // Остановка стандартного поведения (например, добавление новой строки)
            handleAddNegative(); // Вызов функции handleAddKeyword
        }
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Picker
                    cancelText="Отменить"
                    confirmText="Добавить"
                    mouseWheel={true}
                    columns={basicColumns}
                    visible={timeVisible}
                    onClose={() => {
                        setTimeVisible(false)
                    }}
                    onConfirm={v => {
                        const adjustTimeWithShift = (shiftTimer) => {
                            const updatedTimers = new Set([...timers, shiftTimer]);
                            return Array.from(updatedTimers);
                        };

                        const shiftedTimer = (addTimer) => {
                            const [hours, minutes] = addTimer.split(':').map(Number);
                            const newHours = (hours - timezone + 24) % 24;

                            const timerToDelete = `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`

                            return timerToDelete;
                        }

                        const newTimer = v.join('');
                        const shiftTimer = shiftedTimer(newTimer);
                        const newTimers = adjustTimeWithShift(shiftTimer);
                        setTimers(newTimers);
                    }}
                />
                <Section className='sectionChannelTimers sectionChannelSources sectionChannelTimersList' header='Ключевые слова' footer='Добавьте ключевые слова для фильтрации новостей по заголовкам, или оставьте список пустым, чтобы получать все новости. В Telegram-каналах и группах/пабликах VK поиск осуществляется по всему содержанию.'>
                    {keywords.map((keyword, index) => (
                        <Cell key={index} after={<CancelIcon onClick={() => handleDeleteKeyword(keyword)} />}>
                            {keyword}
                        </Cell>
                    ))}
                    <Input after={<IconButton disabled={!keywordRef} onClick={handleAddKeyword} className="addSource" size="m"><AddIcon /></IconButton>} value={keywordRef} onKeyPress={handleKeywordsPress} onChange={e => setKeywordRef(e.target.value)} status="focused" header="Input" placeholder="Введите ключевое слово..." />
                </Section>
                <Section className='sectionChannelTimers sectionChannelSources sectionChannelTimersList' header='Стоп-слова' footer='Добавьте стоп-слова, чтобы исключить нежелательные новости по заголовкам. В Telegram-каналах и группах/пабликах VK стоп-слова применяются ко всему содержанию.'>
                    {negative.map((neg, index) => (
                        <Cell key={index} after={<CancelIcon onClick={() => handleDeleteNegative(neg)} />}>
                            {neg}
                        </Cell>
                    ))}
                    <Input after={<IconButton disabled={!negativeRef} onClick={handleAddNegative} className="addSource" size="m"><AddIcon /></IconButton>} value={negativeRef} onKeyPress={handleNegativePress} onChange={e => setNegativeRef(e.target.value)} status="focused" header="Input" placeholder="Введите стоп-слово..." />
                </Section>
            </AppRoot>
        </div>
    );
};

export default FilterPage;